// extracted by mini-css-extract-plugin
export var clear_icon = "Search-module--clear_icon--a6a44";
export var globalsearch = "Search-module--globalsearch--b5952";
export var mic_icon = "Search-module--mic_icon--14e9e";
export var mobileMenu = "Search-module--mobileMenu--23427";
export var search_icon = "Search-module--search_icon--7d6d6";
export var search_icon1 = "Search-module--search_icon1--d9c4a";
export var searchicon = "Search-module--searchicon--1d062";
export var searchinput = "Search-module--searchinput--ae56a";
export var titleSec = "Search-module--titleSec--e8b5c";
export var topdropdownmwnu = "Search-module--topdropdownmwnu--a95c5";